// import { Gantt } from 'gantt-task-react'
// @ts-ignore
import 'gantt-task-react/dist/index.css'
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import { getCSS } from '_metronic/assets/ts/_utils'
// import HorizontalProgressBar from '../../../Dashboard/Components/HorizontalProgressBar'
import StakingWeekChart from './StakingWeekChart'
// import useViewModel from '../ViewModel'

interface StakeChartProps {
  color: string
  value: number
  secondaryColor?: string
}

const StakeChart: React.FC<StakeChartProps> = ({ color, secondaryColor, value }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, value])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, color, value, secondaryColor)
    )
    if (chart) {
      chart.render()
    }

    return chart
  }

  return (
    <>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_stake_chart'
        className='mixed-widget-4-chart'
        style={{ height: '155px' }}></div>
      {/* end::Chart */}

      <style>
        {`
            #kt_charts_stake_chart .apexcharts-legend {
                display: flex;
                flex-direction: row;
            }
        `}
      </style>
    </>
  )
}

function getChartOptions (
  height: number,
  color: string,
  value: number,
  secondaryColor?: string
): ApexOptions {
  return {
    series: [value],
    chart: {
      type: 'radialBar',
      height: height,
      offsetY: 20,
    },
    colors: [color, secondaryColor || '#E4E6EF'],
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
      position: 'bottom',
      floating: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    grid: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '70%',
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: color,
            fontSize: '20px',
            fontWeight: '700',
            offsetY: 6,
            show: true,
            formatter (val) {
              return val + ''
            },
          },
        },
        track: {
          background: secondaryColor,
          strokeWidth: '100%',
        },
      },
    },
  }
}

interface Props {
  project?: any
  maintenance: any[]
}

const Overview: React.FC<Props> = ({ project }) => {
  return (
    <div className='row mb-5 gy-5'>
      <div className='col-xl-6 col-12'>
        <div className='card h-100'>
          <div className='card-header'>
            {/* Title */}
            <div className='card-title fw-bolder'>จำนวนเสาของหน่วยงานนี้</div>
          </div>

          <div className='card-body'>
            {/* Chart */}
            <div className='row align-items-center justify-content-center h-100'>
              <div className='col-12 col-xl-4 text-center d-flex flex-column align-items-center'>
                <StakeChart
                  color='#00B074'
                  secondaryColor='#91d7c0'
                  value={project?.totalPileHammeredSuccess ?? 0}
                />
                <span>จำนวนเสาเข็มที่ตอกสำเร็จ (ต้น)</span>
              </div>

              <div className='col-12 col-xl-4 text-center d-flex flex-column align-items-center'>
                <StakeChart
                  color='#FF5B5B'
                  secondaryColor='#fb9c9c'
                  value={project?.totalPileHammeredWasted ?? 0}
                />
                <span>จำนวนเสาเข็มที่ตอกเสีย (ต้น)</span>
              </div>

              <div className='col-12 text-center d-flex flex-column align-items-center'>
                <StakeChart
                  color='#2D9CDB'
                  secondaryColor='#a3cde5'
                  value={project?.stockQuantity ?? 0}
                />
                <span>จำนวนเสาที่อยู่ในสต็อก (ท่อน)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end:: Stake Overview Chart */}

      {/* begin:: Summary of Maintenance */}
      <div className='col-xl-6 col-12'>
        <div className='card h-100'>
          <div className='card-header'>
            <div className='card-title fw-bolder'>ภาพรวมการแจ้งหยุดงาน</div>
          </div>

          <div className='card-body d-flex flex-column justify-content-center'>
            <StakingWeekChart color='#2D9CDB' lightColor='#f1faff' />
          </div>
        </div>
      </div>
      {/* end:: Summary of Maintenance */}
    </div>
  )
}

export default Overview
